module.exports = __webpack_public_path__ + "img/40_38_069_720.8964b391.jpg";